var map = {
	"./css.svg": "nbe3",
	"./csv.svg": "EnYD",
	"./doc.svg": "MQGx",
	"./docx.svg": "zhBI",
	"./html.svg": "NUsx",
	"./jpeg.svg": "g+6l",
	"./jpg.svg": "3Xqq",
	"./js.svg": "d+Dl",
	"./mp4.svg": "XDh+",
	"./pdf.svg": "8tvZ",
	"./png.svg": "Gn1d",
	"./svg.svg": "42tu",
	"./xls.svg": "M381",
	"./xlsx.svg": "T/PZ",
	"./xml.svg": "DLEW",
	"./zip.svg": "jC4D"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MSC2";


//////////////////
// WEBPACK FOOTER
// ./static/img/file ^\.\/.*\.svg$
// module id = MSC2
// module chunks = 15